const PUBLIC_API_BASE = 'https://api.cmforgedbyfire.com/card-vault'
const LOCAL_API_HOSTS = new Set(['10.77.77.1', '127.0.0.1', 'localhost'])

export function getApiUrl(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error('API paths must begin with a slash.')
  }

  return LOCAL_API_HOSTS.has(window.location.hostname)
    ? path
    : `${PUBLIC_API_BASE}${path}`
}
